import React, { FC, useCallback } from "react";
import { CaptionProps } from "react-day-picker";

import { addMonths } from "date-fns";

import { NavBarElement } from "../Pickers/NavBarElement";

interface ICustomNavBarElementProps extends CaptionProps {
  showMonthPicker: boolean;
  onChangeDirection?: (direction: boolean) => void;
  onMonthChange?: (month: Date) => void;
  onClick?: () => void;
  month: Date;
}

export const CustomNavBarElement: FC<ICustomNavBarElementProps> = ({
  month,
  showMonthPicker = false,
  onChangeDirection,
  onMonthChange,
}) => {
  const nextMonth = showMonthPicker
    ? addMonths(month, 12)
    : addMonths(month, 1);
  const previousMonth = showMonthPicker
    ? addMonths(month, -12)
    : addMonths(month, -1);

  const onNextClick = useCallback(() => {
    if (onChangeDirection) {
      onChangeDirection(true);
    }
    if (onMonthChange) {
      onMonthChange(nextMonth);
    }
  }, [nextMonth, onChangeDirection, onMonthChange]);

  const onPreviousClick = useCallback(() => {
    if (onChangeDirection) {
      onChangeDirection(false);
    }
    if (onMonthChange) {
      onMonthChange(previousMonth);
    }
  }, [onChangeDirection, onMonthChange, previousMonth]);

  return (
    <NavBarElement
      onNextClick={onNextClick}
      onPreviousClick={onPreviousClick}
    />
  );
};
